// dependencies
import React, { useEffect, useState } from "react";

// components
import SelectInput, { Result } from "../../../../../components/Inputs/SelectInput";

// store
import useQueryBuilderStore from "../store";

interface BaseProps {
	onChange: (value: any) => void;
	value: unknown;
}

const GroupPicker = (props: BaseProps) => {
	const { onChange, value } = props;
	const [fields, setFields] = useState<Result[]>([]);
	const [fetchGroups] = useQueryBuilderStore((state) => [state.fetchGroups]);

	const getGroups = async () => {
		const groups = await fetchGroups();
		setFields(groups);
	};

	useEffect(() => {
		getGroups();
	}, []);

	return <SelectInput results={fields} onChange={onChange} value={value as Result} />;
};

export default GroupPicker;
